import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  TextField,
} from '@mui/material';

interface UploadDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: (file: File | null) => void;
  dialogTitle?: string;
}

const UploadDialog: React.FC<UploadDialogProps> = ({ open, onClose, onUpload, dialogTitle = "Upload File" }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    setSelectedFile(file);
  };

  const handleUploadClick = () => {
    onUpload(selectedFile);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* <Typography variant="body1">{dialogTitle}</Typography> */}
          <TextField
            type="file"
            inputProps={{ accept: ".csv" }}
            onChange={handleFileChange}
            fullWidth
            sx={{  borderRadius: '4px', padding: '5px' }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between" sx={{ padding: 2 }}>
          <Button variant="outlined" onClick={onClose} sx={{ width: '45%' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUploadClick}
            sx={{ width: '45%' }}
            disabled={!selectedFile}
          >
            Upload
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
